export default __webpack_public_path__ + "static/media/pw.5948ddc6.svg";